module.exports = __webpack_public_path__ + "media/images/common/more-arrow-w-69fa4bdf9098e4fc0819661b9be0eca4.svg";